import { render, staticRenderFns } from "./_code.vue?vue&type=template&id=2ce5a376&scoped=true"
import script from "./_code.vue?vue&type=script&lang=js"
export * from "./_code.vue?vue&type=script&lang=js"
import style0 from "./_code.vue?vue&type=style&index=0&id=2ce5a376&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce5a376",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce5a376')) {
      api.createRecord('2ce5a376', component.options)
    } else {
      api.reload('2ce5a376', component.options)
    }
    module.hot.accept("./_code.vue?vue&type=template&id=2ce5a376&scoped=true", function () {
      api.rerender('2ce5a376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/_code.vue"
export default component.exports